import { type ReactNode } from 'react'

import { type InsightsPanel } from '../../payload/panels'
import { usePeriod } from '../../payload/PeriodContext'
import { EmptyState, Missing } from '../components'

/**
 * Chooses between the two empty states, so a call site cannot get it wrong: the
 * developer message only when the panel was never built, else the human one.
 * Lives with the sections rather than the components because it reads the data.
 */
export const useBlank = (): ((
  name: InsightsPanel,
  text: string
) => ReactNode) => {
  const { panels } = usePeriod()
  // Presence of the key, not of rows: a panel the query built with nothing in
  // it (nothing broke, ever) is a result and gets the human wording.
  return (name, text) =>
    panels[name] !== undefined ? (
      <EmptyState text={text} />
    ) : (
      <Missing name={name} />
    )
}
